import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Firestore bağlantısı için firebase dosyanızdan içe aktarım yapın
import { collection, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore'; // Firestore metodları
import './ilanlar.css';

const AdminJobManagement = () => {
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingJobId, setEditingJobId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    positionName: '',
    employmentType: '',
    location: '',
    jobDescription: '',
    qualifications: [],
  });

  useEffect(() => {
    const fetchJobPostings = async () => {
      setLoading(true);
      try {
        const querySnapshot = await getDocs(collection(db, 'jobPostings'));
        const jobs = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setJobPostings(jobs);
      } catch (error) {
        console.error('Veri alınırken hata oluştu:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobPostings();
  }, []);

  const handleToggleMode = async (id, currentMode) => {
    const newMode = currentMode === 'active' ? 'passive' : 'active';
    try {
      const jobRef = doc(db, 'jobPostings', id);
      await updateDoc(jobRef, { mode: newMode });
      setJobPostings(
        jobPostings.map((job) =>
          job.id === id ? { ...job, mode: newMode } : job
        )
      );
    } catch (error) {
      console.error('Mod değiştirilirken hata oluştu:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'jobPostings', id));
      setJobPostings(jobPostings.filter((job) => job.id !== id));
    } catch (error) {
      console.error('İlan silinirken hata oluştu:', error);
    }
  };

  const handleEdit = (job) => {
    setEditingJobId(job.id);
    setEditFormData({
      positionName: job.positionName,
      employmentType: job.employmentType,
      location: job.location,
      jobDescription: job.jobDescription,
      qualifications: job.qualifications,
    });
  };

  const handleEditChange = (e) => {
    setEditFormData({
      ...editFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditQualificationChange = (index, event) => {
    const newQualifications = [...editFormData.qualifications];
    newQualifications[index] = event.target.value;
    setEditFormData({
      ...editFormData,
      qualifications: newQualifications,
    });
  };

  const handleAddQualification = () => {
    setEditFormData({
      ...editFormData,
      qualifications: [...editFormData.qualifications, ''],
    });
  };

  const handleRemoveQualification = (index) => {
    const newQualifications = editFormData.qualifications.filter(
      (_, i) => i !== index
    );
    setEditFormData({
      ...editFormData,
      qualifications: newQualifications,
    });
  };

  const handleSaveEdit = async (id) => {
    try {
      const jobRef = doc(db, 'jobPostings', id);
      await updateDoc(jobRef, editFormData);
      setJobPostings(
        jobPostings.map((job) =>
          job.id === id ? { ...job, ...editFormData } : job
        )
      );
      setEditingJobId(null); // Düzenleme modundan çık
    } catch (error) {
      console.error('İlan düzenlenirken hata oluştu:', error);
    }
  };

  const handleCancelEdit = () => {
    setEditingJobId(null);
  };

  if (loading) {
    return <p className="loading">Yükleniyor...</p>;
  }

  return (
    <div className="admin-job-management-container">
      <h2 className="title">İş İlanları Yönetimi</h2>
      {jobPostings.length > 0 ? (
        jobPostings.map((job) => (
          <div key={job.id} className="job-card">
            {editingJobId === job.id ? (
              <div className="edit-form">
                <input
                  type="text"
                  name="positionName"
                  value={editFormData.positionName}
                  onChange={handleEditChange}
                  placeholder="Pozisyon İsmi"
                />
                <select
                  name="employmentType"
                  value={editFormData.employmentType}
                  onChange={handleEditChange}
                >
                  <option value="">Çalışma Şekli Seçin</option>
                  <option value="Tam Zamanlı">Tam Zamanlı</option>
                  <option value="Yarı Zamanlı">Yarı Zamanlı</option>
                </select>
                <select
                  name="location"
                  value={editFormData.location}
                  onChange={handleEditChange}
                >
                  <option value="">Konum Seçin</option>
                  <option value="Samsun">Samsun</option>
                  <option value="İstanbul">İstanbul</option>
                </select>
                <textarea
                  name="jobDescription"
                  value={editFormData.jobDescription}
                  onChange={handleEditChange}
                  placeholder="İlan Metni"
                ></textarea>
                {editFormData.qualifications.map((qualification, index) => (
                  <div key={index} className="qualification-group">
                    <input
                      type="text"
                      value={qualification}
                      onChange={(event) =>
                        handleEditQualificationChange(index, event)
                      }
                      placeholder={`Nitelik ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveQualification(index)}
                    >
                      Sil
                    </button>
                  </div>
                ))}
                <button type="button" onClick={handleAddQualification}>
                  Nitelik Ekle
                </button>
                <button
                  className="save-button"
                  onClick={() => handleSaveEdit(job.id)}
                >
                  Kaydet
                </button>
                <button className="cancel-button" onClick={handleCancelEdit}>
                  İptal
                </button>
              </div>
            ) : (
              <>
                <h3 className="job-title">{job.positionName}</h3>
                <p>
                  <strong>Konum:</strong> {job.location}
                </p>
                <p>
                  <strong>Çalışma Şekli:</strong> {job.employmentType}
                </p>
                <p>
                  <strong>Mod:</strong> {job.mode}
                </p>
                <button
                  className="edit-button"
                  onClick={() => handleEdit(job)}
                >
                  Düzenle
                </button>
                <button
                  className="toggle-button"
                  onClick={() => handleToggleMode(job.id, job.mode)}
                >
                  {job.mode === 'active' ? 'Pasif Yap' : 'Aktif Yap'}
                </button>
                <button
                  className="delete-button"
                  onClick={() => handleDelete(job.id)}
                >
                  Sil
                </button>
              </>
            )}
          </div>
        ))
      ) : (
        <p className="no-jobs">Henüz aktif iş ilanı yok.</p>
      )}
    </div>
  );
};

export default AdminJobManagement;
